module.exports = __webpack_public_path__ + "d3f76fc74b5d61add3326f319ec2b575.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-24.png
// module id = 2135
// module chunks = 0